import Head from 'next/head';

interface Props {
  children: React.ReactNode;
  defaultTitle?: string;
  fontsToInclude?: string[];
}

export default function HeadAmend({ children, defaultTitle, fontsToInclude }: Props) {
  return (
    <>
      {fontsToInclude && (
        <Head>
          {defaultTitle && <title>{defaultTitle}</title>}
          {fontsToInclude.map((font, i) => (
            <link key={i} rel="stylesheet" href={font} />
          ))}
        </Head>
      )}
      {children}
    </>
  );
}
